import { render, staticRenderFns } from "./ResourcesHome.vue?vue&type=template&id=3b4568c0&scoped=true&"
import script from "./ResourcesHome.vue?vue&type=script&lang=js&"
export * from "./ResourcesHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4568c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b4568c0')) {
      api.createRecord('3b4568c0', component.options)
    } else {
      api.reload('3b4568c0', component.options)
    }
    module.hot.accept("./ResourcesHome.vue?vue&type=template&id=3b4568c0&scoped=true&", function () {
      api.rerender('3b4568c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/home/components/ResourcesHome.vue"
export default component.exports